//
// Wrapper functions that handle checking whether lux.js is available.
//
const LUX = window.LUX || null;
export function startNewPageView() {
    if (LUX) {
        LUX.send();
        LUX.init();
    }
}
export function markLoadTime() {
    if (LUX) {
        LUX.markLoadTime();
    }
}
export function addData(name, value) {
    if (LUX) {
        LUX.addData(name, value);
    }
}
export function mark(name) {
    if (LUX) {
        LUX.mark(name);
    }
}
export function measure(name, startMark, endMark) {
    if (LUX) {
        LUX.measure(name, startMark, endMark);
    }
}
